// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NumberedListItem_wrapper__MLf8C","bulletWrapper":"NumberedListItem_bulletWrapper__K3a5A","bullet":"NumberedListItem_bullet__LSqbJ"};